/**
 * Auto select nearest size when unavailable. Retain size when manually selected by user.
  */
(function() {
  'use strict';

  // Rename "Colors" combined listing dimension label to "Color" at render time
  function renameColorsLegends() {
    document.querySelectorAll('variant-picker legend').forEach(function(legend) {
      if (legend.textContent.trim() === 'Colors:') {
        legend.textContent = 'Color:';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', renameColorsLegends);
  // variant:change bubbles and fires after the picker re-renders; product:rerender does not bubble,
  // so a document listener never receives it and the legend would revert to "Colors:" after a size change.
  document.addEventListener('variant:change', renameColorsLegends);
  document.addEventListener('dialog:after-show', function(event) {
    if (event.target.matches('quick-buy-modal')) renameColorsLegends();
  }, true);

  let userSelectedSize = false;

  // Carries the selected size across a combined-listing color switch (each colour is a separate
  // product, so the sibling otherwise loads fresh). Survives the full-page navigation on the PDP.
  const RETAINED_SIZE_KEY = 'tt_retained_size';
  const COMBINED_SWATCH_SELECTOR = 'a.color-swatch[href*="/products/"], a.block-swatch[href*="/products/"], a.thumbnail-swatch[href*="/products/"]';

  // Find the fieldset whose size we auto-adjust. The combined-listing dimension renders its
  // swatches as <a> links to sibling products (same selector combined-listing-inventory.js uses),
  // which shifts the simple [Color, Size] layout — so we exclude it and take the remaining option.
  function getSizeFieldset(variantPicker) {
    const combinedSelector = COMBINED_SWATCH_SELECTOR;
    const allFieldsets = Array.from(variantPicker.querySelectorAll('fieldset'));
    const realFieldsets = allFieldsets.filter(fs => !fs.querySelector(combinedSelector));

    if (realFieldsets.length < allFieldsets.length) {
      // Combined listing: size is the (typically only) non-combined option.
      return realFieldsets[realFieldsets.length - 1] || null;
    }
    // Regular product: size is the second option.
    return allFieldsets.length >= 2 ? allFieldsets[1] : null;
  }

  document.addEventListener('click', function(event) {
    const variantPicker = event.target.closest('variant-picker');
    if (!variantPicker) return;

    const sizeFieldset = getSizeFieldset(variantPicker);
    if (!sizeFieldset) return;

    const clickedInput = event.target.closest('input[data-option-name]')
                      || event.target.closest('label')?.querySelector('input[data-option-name]');

    if (clickedInput && sizeFieldset.contains(clickedInput)) {
      userSelectedSize = true;
    }
  });

  // When a combined-listing colour swatch is clicked, remember the currently selected size so we
  // can re-apply it once the sibling product loads (runs before the quick-buy swap / PDP navigation).
  document.addEventListener('click', function(event) {
    const swatch = event.target.closest(COMBINED_SWATCH_SELECTOR);
    if (!swatch) return;

    const variantPicker = swatch.closest('variant-picker');
    if (!variantPicker) return;

    const sizeFieldset = getSizeFieldset(variantPicker);
    const checked = sizeFieldset && sizeFieldset.querySelector('input:checked');
    if (!checked) return;

    try { sessionStorage.setItem(RETAINED_SIZE_KEY, checked.getAttribute('data-option-name')); } catch(e) {}
  });

  // Re-select the retained size on the freshly loaded sibling. Returns true if it changed selection.
  function applyRetainedSize(variantPicker) {
    let retained = null;
    try { retained = sessionStorage.getItem(RETAINED_SIZE_KEY); } catch(e) {}
    if (!retained) return false;
    try { sessionStorage.removeItem(RETAINED_SIZE_KEY); } catch(e) {}

    const sizeFieldset = getSizeFieldset(variantPicker);
    if (!sizeFieldset) return false;

    const match = Array.from(sizeFieldset.querySelectorAll('input[data-option-name]'))
      .find(input => input.getAttribute('data-option-name') === retained);
    // Keep the explicitly chosen size even when it's sold out in this colour (it renders as a
    // disabled/sold-out selection). Only bail if the size doesn't exist here or is already selected.
    if (!match || match.disabled || match.checked) return false;

    userSelectedSize = true;
    match.checked = true;
    match.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  // Auto-select nearest available size when the initially rendered variant is unavailable.
  function autoSelectIfUnavailable(variantPicker) {
    const variantScript = variantPicker.querySelector('script[data-variant]');
    if (!variantScript) return;

    try {
      const variant = JSON.parse(variantScript.textContent);
      if (!variant || variant.available) return;
    } catch(e) { return; }

    const formId = variantPicker.getAttribute('form-id');
    if (formId) doAutoSelect(formId);
  }

  // Retained size takes precedence; otherwise fall back to nearest-available auto-select.
  function refreshSizeSelection(variantPicker) {
    if (applyRetainedSize(variantPicker)) return;
    autoSelectIfUnavailable(variantPicker);
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('variant-picker').forEach(function(variantPicker) {
      setTimeout(function() { refreshSizeSelection(variantPicker); }, 100);
    });
  });

  document.addEventListener('dialog:after-show', function(event) {
    if (!event.target.matches('quick-buy-modal')) return;

    userSelectedSize = false;

    event.target.querySelectorAll('variant-picker').forEach(function(variantPicker) {
      setTimeout(function() { refreshSizeSelection(variantPicker); }, 100);
    });
  }, true);

  document.addEventListener('variant:change', function(event) {
    const { variant } = event.detail;
    if (!variant || variant.available) return;

    if (userSelectedSize) return;

    const form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    setTimeout(() => doAutoSelect(form.getAttribute('id')), 100);
  });

  function doAutoSelect(formId) {
    const variantPicker = document.querySelector(`variant-picker[form-id="${formId}"]`)
                       || document.querySelector('variant-picker');
    if (!variantPicker) return;

    const sizeFieldset = getSizeFieldset(variantPicker);
    if (!sizeFieldset) return;

    const selectedSizeInput = sizeFieldset.querySelector('input:checked');
    if (!selectedSizeInput) return;

    const currentSize = selectedSizeInput.getAttribute('data-option-name');

    const allSizeInputs = Array.from(sizeFieldset.querySelectorAll('input[data-option-name]'));
    const allSizes = allSizeInputs.map(input => input.getAttribute('data-option-name'));
    const currentSizeIndex = allSizes.indexOf(currentSize);

    // Determine available sizes from the rendered DOM — works for any number of variants
    // since availability comes from the Section Rendering API response, not a truncated JSON blob.
    const availableSizes = allSizeInputs
      .filter(input => {
        if (input.disabled) return false;
        const label = sizeFieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        return !label || !label.classList.contains('is-disabled');
      })
      .map(input => input.getAttribute('data-option-name'));

    if (availableSizes.length === 0) return;

    const nearestSize = findNearestSize(allSizes, currentSizeIndex, availableSizes);
    if (!nearestSize || nearestSize === currentSize) return;

    const sizeInput = sizeFieldset.querySelector(`input[data-option-name="${nearestSize}"]`);
    if (sizeInput && !sizeInput.checked) {
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function findNearestSize(allSizes, currentIndex, availableSizes) {
    for (let distance = 1; distance < allSizes.length; distance++) {
      const smaller = currentIndex - distance;
      if (smaller >= 0 && availableSizes.includes(allSizes[smaller])) {
        return allSizes[smaller];
      }
      const larger = currentIndex + distance;
      if (larger < allSizes.length && availableSizes.includes(allSizes[larger])) {
        return allSizes[larger];
      }
    }
    return availableSizes[0];
  }
})();
